import HttpTool from "../utils/network/httpTool";
import {BridgeHelper} from "../utils/bridgeHelper";
import {API_Service, GetAPIBaseURL} from "../utils/network/API";


class CommonService {
	constructor(apiService) {
		this.apiService = apiService || API_Service.appointment;
	}
	fetchData = (api, param, success, fail, isEnableSpinner= true) => {
		let baseUrl = GetAPIBaseURL(this.apiService);
		let apiHash = HttpTool.post(baseUrl, api, param, (response) => {
			isEnableSpinner && BridgeHelper.hideSpinner(apiHash)
			success && success(response)
		}, (error) => {
			isEnableSpinner && BridgeHelper.hideSpinner(apiHash)
			fail && fail(error)
		});
		isEnableSpinner && BridgeHelper.showSpinner(apiHash)
	}
}

export {CommonService}
